import { EVENT_CLICK_COMPLEMENTARY } from '~~/constants/googleTagManager';

export const buildClickComplementaryTags = (id: string) => ({
  event: EVENT_CLICK_COMPLEMENTARY,
  items: {
    complementary_id: id,
  },
});
